import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import { Modal } from 'react-bootstrap';
import { hideUMOModifyDialog } from '../../actions/mainUI';
import { addIntlInfo } from '../../actions/messageDialog';
import ResizeDialog from './ResizeDialog';
import ZipDownloadDialog from './ZipDownloadDialog';
import PdfDownloadDialog from './PdfDownloadDialog';
import * as modTypes from '../../constants/umoModifications';
import { getWorkspaceDownloadOptions } from '../../actions/umoUtils';
import ImageEditModal from '../ImageEditModal';
import { deselectAll } from '../../actions/umoGallery';
import { deselectAll as deselectAllWS } from '../../actions/workspacePreview';

const mapStateToProps = (state) => ({
  umoUtils: state.umoUtils,
  umoGallery: state.umoGallery,
});

const mapDispatchToProps = (dispatch) => ({
  onDialogHide: () => dispatch(hideUMOModifyDialog()),
  addMessage: (msgID) => dispatch(addIntlInfo(msgID)),
  getDownloadOptions: (workspaceID) =>
    dispatch(getWorkspaceDownloadOptions(workspaceID)),
  dispatch: (actionToDispatch) => dispatch(actionToDispatch),
});

class UMOModifyDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
      error: null,
      isSuccess: false,
      type: '',
      width: 800,
      dpi: '',
      quality: 85,
      embedMeta: true,
      createDeriv: false,
    };

    this.onCloseClick = this.onCloseClick.bind(this);
    this.getViewByType = this.getViewByType.bind(this);
    this.hideUMOModifyDialog = this.hideUMOModifyDialog.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.isShown !== prevProps.isShown && this.props.isShown) {
      this.props.getDownloadOptions(this.props.workspaceID);
    }
  }

  hideUMOModifyDialog(shouldDeselectAll) {
    if (shouldDeselectAll) {
      if (this.props.data?.get('isPinnedWorkspace')) this.props.dispatch(deselectAllWS())
      else this.props.dispatch(deselectAll());
    }
    this.props.onDialogHide();
  }

  onCloseClick() {
    this.setState({
      isSubmitting: true,
    });
    this.props.onDialogHide();
  }

  getViewByType() {
    // override the gallery select all in case gallery is selected
    // but the resize function is used via grid item overlay menu
    // meaning, just that umo should be resized
    const isSelectAll =
      this.props.data &&
      !this.props.data.get('selectAllOverride') &&
      this.props.umoGallery.get('isSelectAll');
    const modType = this.props.data && this.props.data.get('modType');
    const isBatchDownload =
      this.props.data && this.props.data.get('isBatchDownload');
    let view;
    switch (modType) {
      case modTypes.UMO_MODIFY_TYPE_RESIZE:
        view = (
          <ResizeDialog
            hideUMOModifyDialog={this.hideUMOModifyDialog}
            umoList={this.props.umoList}
            workspaceID={this.props.workspaceID}
            addMessage={this.props.addMessage}
            onCloseClick={this.onCloseClick}
            isSelectAll={isSelectAll}
            origWidth={this.props.data?.get('origWidth')}
            dispatch={this.props.dispatch}
          />
        );
        break;
      case modTypes.UMO_MODIFY_TYPE_ZIP_DOWNLOAD:
        view = (
          <ZipDownloadDialog
            hideUMOModifyDialog={this.hideUMOModifyDialog}
            umoList={this.props.umoList}
            workspaceID={this.props.workspaceID}
            addMessage={this.props.addMessage}
            onCloseClick={this.onCloseClick}
            downloadOptions={this.props.umoUtils.get('downloadOptions')}
            isSelectAll={isSelectAll}
            isBatchDownload={isBatchDownload}
            dispatch={this.props.dispatch}
          />
        );
        break;
      case modTypes.UMO_MODIFY_TYPE_PDF_DOWNLOAD:
        view = (
          <PdfDownloadDialog
            hideUMOModifyDialog={this.hideUMOModifyDialog}
            umoList={this.props.umoList}
            workspaceID={this.props.workspaceID}
            addMessage={this.props.addMessage}
            onCloseClick={this.onCloseClick}
            isSelectAll={isSelectAll}
            dispatch={this.props.dispatch}
          />
        );
        break;
      case modTypes.UMO_MODIFY_TYPE_IMAGE_EDIT_ROTATE:
      case modTypes.UMO_MODIFY_TYPE_IMAGE_EDIT_MIRRROR:
        view = (
          <ImageEditModal
            modalData={this.props.data}
            onModalCloseClick={this.hideUMOModifyDialog}
          />
        );
        break;
      case modTypes.UMO_MODIFY_TYPE_CROP:
      case modTypes.UMO_MODIFY_TYPE_COPY:
      case modTypes.UMO_MODIFY_TYPE_ROTATE:

      default:
        break;
    }
    return view;
  }

  render() {
    const viewType = this.getViewByType();
    const modType = this.props.data && this.props.data.get('modType');
    return (
      <div className="workspace-dialog">
        <Modal
          show={this.props.isShown}
          onHide={this.hideUMOModifyDialog}
          onExited={this.props.onDialogHide}
          backdrop={this.state.isSubmitting ? 'static' : true}
          dialogClassName={classNames('workspace-dialog__overlay')}
          size={
            modType === modTypes.UMO_MODIFY_TYPE_IMAGE_EDIT_ROTATE ||
            modType === modTypes.UMO_MODIFY_TYPE_IMAGE_EDIT_MIRRROR
              ? 'xl'
              : undefined
          }
        >
          <button
            onClick={this.onCloseClick}
            className="workspace-dialog__close-button"
          />
          {viewType}
        </Modal>
      </div>
    );
  }
}

UMOModifyDialog.propTypes = {
  isShown: PropTypes.bool,
  data: PropTypes.instanceOf(Map),
  umoList: PropTypes.instanceOf(Array),
  workspaceID: PropTypes.string,
  onDialogHide: PropTypes.func,
  addMessage: PropTypes.func,
  getDownloadOptions: PropTypes.func,
  dispatch: PropTypes.func,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(UMOModifyDialog)
);
